import { useCallback, useEffect, useState } from 'react';

import useGlobalState from 'actions';
import Page from 'components/Page';
import {
  useRGetApplicationData,
  useRGetSavedApplication,
} from '@repositories/new-application/queries';
import { useSnackbar } from '@new-components/elements';
import { useProfile } from '@hooks/use-profile';
import { useHistory } from 'react-router-dom';
import { useRGetGrabFeatureSettings } from '@repositories/common';

import Step from './components/application-step';
import { ApplicationForms } from './constants';
import { applicationPageCx, applicationPageContentCx } from './styles';

const Application = () => {
  const history = useHistory();
  const [, actions] = useGlobalState();
  const { onOpen } = useSnackbar();

  const [step, setStep] = useState(0);
  const [isSyncedStep, setIsSyncedStep] = useState(false);

  const ApplicationForm = ApplicationForms[step];

  useRGetGrabFeatureSettings(
    {
      featureName: 'grab_disable_ajukan_pinjaman',
    },
    {
      onSuccess: (result) => {
        if (result.data.isActive) {
          history.push('/maintenance');
        }
      },
    },
  );

  const handleGoBack = useCallback(() => {
    setStep((prev) => (prev > 0 ? prev - 1 : prev));
  }, []);

  const { data: profile } = useProfile();

  const {
    data: savedApplicationData,
    isInitialLoading: isLoadingGetSavedApplicationData,
    isPaused: isPausedGetSavedApplicationData,
  } = useRGetSavedApplication({
    enabled: true,
    step: step + 1,
    onSuccess: () => {
      if (
        profile &&
        ![100, 106, 135].includes(profile?.application.applicationStatus)
      ) {
        history.replace('/home');
      }
    },
  });

  useRGetApplicationData({
    page: step + 1,
    enabled: step < 3,
    onError: (err) => {
      onOpen({
        message:
          (err.payload?.errors as Array<string>)?.[0] ||
          'Oops, Something went wrong.',
        severity: 'error',
      });
    },
  });

  useEffect(() => {
    if (isLoadingGetSavedApplicationData || isPausedGetSavedApplicationData) {
      actions.openLoadingOverlay();
    } else {
      actions.closeLoadingOverlay();
    }
  }, [
    actions,
    isLoadingGetSavedApplicationData,
    isPausedGetSavedApplicationData,
    profile,
  ]);

  useEffect(() => {
    if (localStorage.getItem('change_loan')) {
      localStorage.removeItem('change_loan');
      setStep(2);
      setIsSyncedStep(true);
    } else if (savedApplicationData?.data && !isSyncedStep) {
      setStep(savedApplicationData.data.currentStep - 1);
      setIsSyncedStep(true);
    }
  }, [isSyncedStep, savedApplicationData?.data, step]);

  return (
    <Page
      className={applicationPageCx}
      contentClassName={applicationPageContentCx(step)}
      useHeader
    >
      <Step step={step} onGoBack={handleGoBack} />
      {isSyncedStep && <ApplicationForm setStep={setStep} />}
    </Page>
  );
};

export default Application;
